/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import underscore from 'underscore';
import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { GetCustomerEditAtom } from '../store/customerAtom';
import { useRecoilValue } from 'recoil';
import { useEffect } from 'react';
import GeneralSelect from './GeneralSelect';

function AddCustomerOtherInfo(props) {
  const customerToEdit = GetCustomerEditAtom();
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();
  const [allowCustomerPortal, setAllowCustomerPortal] = useState(false);
  const onErrors = errors => console.error(errors);
  const { masterData } = props;

  var masterDataGroup = underscore.groupBy(masterData, 'Master_Type');

  if (masterDataGroup) {
    var paymentTermsList = masterDataGroup[4];
    var currencyList = masterDataGroup[5];
    var priceList = masterDataGroup[6];
    var religionList = masterDataGroup[11];
    var professionList = masterDataGroup[10];
    var genderList = masterDataGroup[8];
    var ageList = masterDataGroup[9];
    var assignOfficerList = masterDataGroup[13];
  }

  useEffect(() => {
    if (customerToEdit?.Customer_Id) {
      setValue('Currency_Id', customerToEdit.Currency_Id);
      setValue('Payment_Term_Id', customerToEdit.Payment_Term_Id);
      setValue('Facebook_URL', customerToEdit.Facebook_URL);
      setValue('Twitter_URL', customerToEdit.Twitter_URL);
      setValue('Referring_Email', customerToEdit.Referring_Email);
      setValue('Referring_Person', customerToEdit.Referring_Person);
      setValue('Customer_Remark', customerToEdit.Customer_Remark);
      setValue('Date_Of_Birth', customerToEdit.Date_Of_Birth);
      setValue('Gender_Id', customerToEdit.Gender_Id);
      setValue('Price_List_Id', customerToEdit.Price_List_Id);
      setValue('Age_Id', customerToEdit.Age_Id);
      setValue('Religion_Id', customerToEdit.Religion_Id);
      setValue('Bus_Stop', customerToEdit.Bus_Stop);
      setValue('Profession_Id', customerToEdit.Profession_Id);
      setValue('officer_id', customerToEdit.Assigned_Officer_Id);
      setValue('customer_portal_access_id', customerToEdit.Customer_Portal_Access_Id);

      if (customerToEdit?.Customer_Portal_Access_Id === 1) {
        setAllowCustomerPortal(true);
      } else {
        setAllowCustomerPortal(false);
      }
    }
  }, [customerToEdit]);

  const onSubmit = () => {
    const formData = getValues();
    props.submitSection(formData);
  };

  const onSelectCurrency = currency => {
    setValue('Currency_Id', currency.Code);
  };



  const onSelectReligion = item => {
    setValue('Religion_Id', item.Code);
  };

  const onSelectAge = item => {
    setValue('Age_Id', item.Code);
  };

  const onOfficerSelect = item => {
    setValue('officer_id', item.Code);
  };

  const onAllowPortal = checked => {
    setAllowCustomerPortal(checked);
    if (checked) {
      setValue('customer_portal_access_id', 1);
    } else {
      setValue('customer_portal_access_id', 2);
    }
  };

  const onSelectProfession = item => {
    setValue('Profession_Id', item.Code);
  };

  const onSelectGender = item => {
    setValue('Gender_Id', item.Code);
  };

  return (
    <section className="w-full max-w-6xl mx-auto mt-6 p-6 bg-white rounded-lg shadow-md">
      <form onSubmit={handleSubmit(onSubmit, onErrors)} className="space-y-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Other Information Section */}
          <section className="space-y-4">
            <h3 className="font-bold text-lg text-gray-900 border-b border-gray-200 pb-2">Other Information</h3>
            <div className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Currency</label>
                  <GeneralSelect onOptionSelect={onSelectCurrency} defaultVal={customerToEdit?.Currency_Name} list={currencyList} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Facebook URL</label>
                  <input
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Facebook URL"
                    {...register('Facebook_URL')}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Twitter URL</label>
                  <input
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Twitter URL"
                    {...register('Twitter_URL')}
                  />
                </div>
              </div>
              
              <div className="col-span-2">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    checked={allowCustomerPortal}
                    className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
                    onChange={e => onAllowPortal(e.target.checked)}
                  />
                  <span className="ml-2 text-sm text-gray-700">Allow customer portal access</span>
                </label>
              </div>
              <div className="col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">Customer Remark</label>
                <textarea
                  {...register('Customer_Remark')}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter comment/remarks"
                  rows={4}
                />
              </div>
            </div>
          </section>

          {/* Personal Information Section */}
          <section className="space-y-4">
            <h3 className="font-bold text-lg text-gray-900 border-b border-gray-200 pb-2">Personal Information</h3>
            <div className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Religion</label>
                  <GeneralSelect onOptionSelect={onSelectReligion} defaultVal={customerToEdit?.Religion_Name} list={religionList} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Profession</label>
                  <GeneralSelect onOptionSelect={onSelectProfession} defaultVal={customerToEdit?.Profession_Name} list={professionList} />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Bus Stop</label>
                  <input
                    {...register('Bus_Stop')}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Enter bus stop/landmark"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Referring Email</label>
                  <input
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Enter referring email"
                    {...register('Referring_Email')}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Referring Person</label>
                  <input
                    {...register('Referring_Person')}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Enter referring person"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Assigned Officer</label>
                  <GeneralSelect
                    onOptionSelect={onOfficerSelect}
                    defaultVal={customerToEdit?.Assigned_Officer_Name}
                    list={assignOfficerList}
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Age</label>
                  <GeneralSelect onOptionSelect={onSelectAge} defaultVal={customerToEdit?.Age_Name} list={ageList} />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Date of Birth</label>
                  <input
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    type="date"
                    {...register('Date_Of_Birth')}
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Gender</label>
                <GeneralSelect onOptionSelect={onSelectGender} defaultVal={customerToEdit?.Gender_Name} list={genderList} />
              </div>
            </div>
          </section>
        </div>

        <div className="flex justify-end pt-4 border-t border-gray-200">
          <button
            type="submit"
            className="bg-blue-500 hover:bg-blue-600 text-white font-medium px-6 py-2 rounded-md transition-colors duration-200"
          >
            Save
          </button>
        </div>
      </form>
    </section>
  );
}

export default AddCustomerOtherInfo;
